import React from "react";

import { Typography } from "minimum-ui/core";
import styled from "styled-components";
import { Spinner } from "ui/core";

import { useAppBusyMessages } from "utilities/hooks/useAppBusy";

import { Backdrop } from "Common";

export const BusyBackdrop: React.FC = () => {
  const { messages } = useAppBusyMessages();
  return (
    <>
      <Backdrop isActive={messages.length > 0} zIndex={10000} opacity={0.8} />
      {messages.length > 0 && (
        <Wrapper>
          <InnerWrapper>
            <Spinner size={60} color="white" />
            <Messages>
              {messages.map((message) => (
                <Typography key={message} variant="bodyMedium" color="white">
                  {message}
                </Typography>
              ))}
            </Messages>
          </InnerWrapper>
        </Wrapper>
      )}
    </>
  );
};

const Wrapper = styled.div`
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  justify-content: center;
  z-index: 10001;
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 10rem;
  color: white;
`;

const Messages = styled.div`
  margin-top: 2rem;
  color: #white;
  font-size: 1rem;
  text-align: center;
  min-height: 5rem;
`;
